import clamp from '../../utils/clamp'
import Desktop, { useIsDesktop } from './Desktop'
import Mobile, { useIsMobile } from './Mobile'
import Tablet, { useIsTablet } from './Tablet'
import { useIsHorizontal } from './Horizontal'

const is: IIsMedia = {
  desktop: useIsDesktop,
  horizontal: useIsHorizontal,
  mobile: useIsMobile,
  tablet: useIsTablet,
}

export { Desktop, Tablet, Mobile, is }

export interface IIsMedia {
  desktop: () => boolean
  mobile: () => boolean
  tablet: () => boolean
  horizontal: () => boolean
}

export const isTouchDevice = 'ontouchstart' in window

export function getDevicePixelRatio() {
  if (window.devicePixelRatio !== undefined) {
    return clamp(window.devicePixelRatio, 1)
  } else {
    return 1
  }
}
